var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3891_2914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 13.3333L11.5556 9.77778L10.3111 8.53333L8.88889 9.95556V6.22222H7.11111V9.95556L5.68889 8.53333L4.44444 9.77778L8 13.3333ZM1.77778 4.44444V14.2222H14.2222V4.44444H1.77778ZM1.77778 16C1.28889 16 0.87037 15.8259 0.522222 15.4778C0.174074 15.1296 0 14.7111 0 14.2222V3.13333C0 2.92593 0.0333333 2.72593 0.1 2.53333C0.166667 2.34074 0.266667 2.16296 0.4 2L1.51111 0.644444C1.67407 0.437037 1.87778 0.277778 2.12222 0.166667C2.36667 0.0555556 2.62222 0 2.88889 0H13.1111C13.3778 0 13.6333 0.0555556 13.8778 0.166667C14.1222 0.277778 14.3259 0.437037 14.4889 0.644444L15.6 2C15.7333 2.16296 15.8333 2.34074 15.9 2.53333C15.9667 2.72593 16 2.92593 16 3.13333V14.2222C16 14.7111 15.8259 15.1296 15.4778 15.4778C15.1296 15.8259 14.7111 16 14.2222 16H1.77778ZM2.13333 2.66667H13.8667L13.1111 1.77778H2.88889L2.13333 2.66667Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3891_2914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.26c2573032b6ed5271ad1bde707e6d72.svg";
export { ForwardRef as ReactComponent };